import { lighten } from '@mui/material/styles';

export const RISK_CARD_HEIGHT = 380;

export const riskCardSx = {
  display: 'flex',
  flexDirection: 'column',
  height: RISK_CARD_HEIGHT,
  maxHeight: RISK_CARD_HEIGHT,
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: 1.5,
  bgcolor: 'background.paper',
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.06)',
  overflow: 'hidden',
};

export const riskCardHeaderSx = {
  px: 2.5,
  pt: 2,
  pb: 1.5,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 1,
  flexShrink: 0,
};

export const riskCardBodySx = {
  px: 2.5,
  pb: 2.5,
  pt: 0,
  flex: '1 1 auto',
  minHeight: 0,
  overflowY: 'auto',
  overflowX: 'hidden',
  WebkitOverflowScrolling: 'touch',
};

export const getRiskCardTitleSx = (theme) => ({
  fontWeight: theme.typography.fontWeightMedium,
  color: theme.palette.text.secondary,
  fontSize: '0.9375rem',
  lineHeight: 1.4,
});

export const getRiskFieldLabelProps = (theme) => ({
  variant: 'body2',
  sx: {
    color: theme.palette.text.secondary,
    fontWeight: theme.typography.fontWeightMedium,
    flex: '0 0 auto',
    maxWidth: '45%',
    pr: 2,
  },
});

export const getRiskFieldValueProps = (theme) => ({
  variant: 'body2',
  sx: {
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightMedium,
    textAlign: 'right',
    flex: 1,
    minWidth: 0,
    wordBreak: 'break-word',
  },
});

export const riskSectionCardSx = {
  p: 3,
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: 1.5,
  bgcolor: 'background.paper',
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.06)',
};

export const getRiskSectionTitleSx = (theme) => ({
  fontWeight: theme.typography.fontWeightMedium,
  color: theme.palette.text.secondary,
  fontSize: '0.9375rem',
  lineHeight: 1.4,
});

export const getRiskBodyTextSx = (theme) => ({
  color: theme.palette.text.secondary,
  lineHeight: 1.6,
});

export const getRiskPreviewPanelSx = (theme) => ({
  p: 2.5,
  mb: 2.5,
  border: '1px solid',
  borderColor: theme.palette.divider,
  borderRadius: 1,
  bgcolor: theme.palette.action.hover,
});

export const getRiskPreviewLabelSx = (theme) => ({
  color: theme.palette.text.secondary,
  mb: 0.25,
});

export const getRiskPreviewValueSx = (theme) => ({
  color: theme.palette.text.primary,
  fontWeight: theme.typography.fontWeightMedium,
});

export const riskToggleGroupSx = {
  mb: 3,
  display: 'flex',
  flexWrap: 'wrap',
  gap: 1,
  '& .MuiToggleButtonGroup-grouped': {
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: '6px !important',
    mx: 0,
  },
  '& .MuiToggleButton-root': {
    textTransform: 'none',
    px: 2,
    py: 0.75,
    fontSize: '0.875rem',
    fontWeight: 500,
    color: 'text.secondary',
    border: 'none',
    '&.Mui-selected': {
      color: 'primary.main',
      bgcolor: 'action.selected',
      borderColor: 'primary.main',
      '&:hover': {
        bgcolor: 'action.selected',
      },
    },
  },
};

export const getRiskNoMatchAlertSx = (theme) => ({
  mt: 2.5,
  p: 2.5,
  border: `1px solid ${theme.palette.warning.main}`,
  borderRadius: 1,
  bgcolor: lighten(theme.palette.warning.main, 0.92),
});

export const getRiskNoMatchTitleSx = (theme) => ({
  color: theme.palette.warning.dark,
  mb: 0.75,
});

export const getRiskNoMatchBodySx = (theme) => ({
  color: theme.palette.warning.dark,
  lineHeight: 1.6,
});

export const getRiskLevelColors = (theme) => ({
  LOW: { dot: theme.palette.success.main, text: theme.palette.success.dark },
  MODERATE: { dot: theme.palette.warning.main, text: theme.palette.warning.dark },
  HIGH: { dot: theme.palette.error.main, text: theme.palette.error.dark },
});

export const getRiskOwnerRowSx = (theme) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 1.5,
  p: 1.25,
  mb: 0.75,
  border: '1px solid',
  borderColor: theme.palette.divider,
  borderRadius: 1,
  bgcolor: theme.palette.action.hover,
  '&:last-child': { mb: 0 },
});

export const getRiskOwnerNameSx = (theme) => ({
  color: theme.palette.text.primary,
  fontWeight: theme.typography.fontWeightMedium,
  fontSize: '0.8125rem',
  lineHeight: 1.35,
});

export const getRiskOwnerNationalitySx = (theme) => ({
  color: theme.palette.text.secondary,
  fontSize: '0.75rem',
  lineHeight: 1.3,
  display: 'block',
  mt: 0.25,
});

export const getRiskOwnerPercentSx = (theme) => ({
  color: theme.palette.text.primary,
  fontWeight: theme.typography.fontWeightMedium,
  fontSize: '0.8125rem',
  lineHeight: 1.35,
});

export const riskButtonSx = {
  textTransform: 'none',
};
